import { inBiliApp, biliBridge } from "@bilibili/js-bridge";

export enum ActionType {
  Other,
  PV,
  Click,
  View,
  System,
  Performance,
  Custom,
  Player
}

// 北极星上报
export function nativeLogger(eventID: string, type: ActionType = ActionType.Click, params = {}) {
  const p = {
    url: location.href,
    ...params
  };
  const pp = JSON.stringify(p);
  biliBridge.callNative({
    method: "ability.reportEventV3",
    data: {
      event: eventID || null,
      params: pp, // JSON字符串，包含load_type，time(h5页调用jsbridge时间)
      type: type, // 0: 其它，1: PV，2: 点击，3: 展现，4: 系统，5: 性能，7: 自定义，9: 播放器
      label: "webviewTracker" // 5.39新增, type为5时标识采用前端与客户端打通的性能上报
    },
    callback: () => {
      // eslint-disable-next-line no-console
      console.log("调用成功");
    }
  });
}

export function logger(eventID: string, type: ActionType = ActionType.Click, params = {}) {
  if (inBiliApp) {
    nativeLogger(eventID, type, params);
  }
}

function reportPerformance() {
  const timing = window.performance.timing;
  const memory = window.performance["memory"];
  const perf = {
    url: window.location.href,
    navigationStart: timing.navigationStart,
    fetchStart: timing.fetchStart,
    domainLookupStart: timing.domainLookupStart,
    domainLookupEnd: timing.domainLookupEnd,
    connectStart: timing.connectStart,
    connectEnd: timing.connectEnd,
    requestStart: timing.requestStart,
    responseStart: timing.responseStart,
    responseEnd: timing.responseEnd,
    domLoading: timing.domLoading,
    domInteractive: timing.domInteractive,
    domContentLoadedEventStart: timing.domContentLoadedEventStart,
    domContentLoadedEventEnd: timing.domContentLoadedEventEnd,
    domComplete: timing.domComplete,
    loadEventStart: timing.loadEventStart,
    loadEventEnd: timing.loadEventEnd,
    fp: window["fp_time"],
    jsHeapSizeLimit: memory?.jsHeapSizeLimit,
    totalJSHeapSize: memory?.totalJSHeapSize,
    usedJSHeapSize: memory?.usedJSHeapSize
  };
  // 客户端暂不支持
  // logger("ott-platform.activityh5.perf.track", ActionType.Performance, perf);
  logger("ott-platform.activityh5.fcp.0.click", ActionType.Click, perf);
}
export function reportH5Tracker() {
  if (document.readyState !== "complete") {
    window.addEventListener("load", () => {
      setTimeout(() => {
        reportPerformance();
      }, 100);
    });
  } else {
    setTimeout(() => {
      reportPerformance();
    }, 100);
  }
}
